import { logUserOut } from "../auth/userAuthUtils";
import { catchAPIError, catchAPIResponse, postFetch, standardPostQuery, successfulJwtValidation } from "./apiUtils.js";

import * as Constants from "../../config/constants/Constants.js";
import { getLanguage } from "../../config/language/language.js";

/**
 * Executed when the JWT has expired.
 */
export const sessionExpired = (props) => {
    props.showSnackbar({ color: "error", message: getLanguage().SNACKBAR_ERROR_SESSION_EXPIRED });
    logUserOut(props, true, "/signin");
};

/**
 * Check if the JWT is still valid - if not, then redirect to log in page.
 * Executed every time the page loads.
 *
 * Includes check whether user has logged in before.
 */
export const checkJWTvalidity = (props) => {
    const options = { showMessage: false };

    postFetch(
        Constants.API_JWT_VALIDATION,
        JSON.stringify({
            token: props.user.userJWT
        })
    )
        .then(function (response) {
            if (Constants.FRONTEND_ONLY) {
                checkDebug(props);
            } else {
                checkNormal(props, response, options);
            }
        })
        .finally(() => {
            setTimeout(function () {
                props.browser.setIsPageLoading(false);
            }, Constants.PAGE_LOADING_MS);
        })
        .catch((err) => catchAPIError(props, err, options));
};

const checkDebug = (props) => {
    console.warn("Debug mode - logging in...");
    // successfulJwtValidation(props, Constants.DEBUG_USER_JWT);
    successfulJwtValidation(props, Constants.DEBUG_ADMIN_JWT);
};

const checkNormal = (props, response, options = {}) => {
    props.server.setIsConnectionToServerEstablished(true);

    if (response.ok && response.body.success) {
        successfulJwtValidation(props);
        props.showSnackbar({ message: getLanguage().SNACKBAR_SUCCESS_SIGNED_IN });
        return;
    }

    // Check if user has logged in before.
    if (props.user.userJWT !== "") {
        sessionExpired(props); // The JWT probably expired.
        return;
    }

    catchAPIResponse(props, response, options);
};

/**
 * Send sign in request to the server.
 * Receive a JWT and save it to localstorage.
 */
export const signIn = (props, data) => {
    const body = JSON.stringify({
        email: data.get("email"),
        password: data.get("password")
    });

    standardPostQuery(
        props,
        Constants.API_LOGIN_PATH,
        body,
        (response) => {
            successfulJwtValidation(props, response.body.access_token);
            props.showSnackbar({ message: getLanguage().SNACKBAR_SUCCESS_SIGNED_IN });
            props.browser.navigate("/home");
        },
        { checkExpired: false }
    );
};

/**
 * Send a sign up request to the server.
 * If successful, redirect to the sign in page.
 */
export const signUp = (props, body) => {
    standardPostQuery(props, Constants.API_SIGNUP_PATH, body, (response) => {
        props.server.setIsConnectionToServerEstablished(true);
        props.showSnackbar({ message: getLanguage().SNACKBAR_SUCCESS_SIGNED_UP });
        props.browser.navigate("/signin");
    });
};
